import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import ProductDataTable from "../components/ProductsDataTable";
import DefaultTopBar from "../components/DefaultTopBar";

const ManagePackages = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout> 

        <DefaultTopBar
            title="Products"
            desc="View, create, edit products."
            btnText="Add New Product"
            btnLink="/add-product" 
        />

        {/* TableDataLayer */}
        <ProductDataTable />

      </MasterLayout>

    </>
  );
};

export default ManagePackages; 
